import { Component,  Input } from '@angular/core';
import { Wrapper } from '../wrapper.component';
import { JoiEvent } from 'globals/store/events.data';
import { EventBackup, EventBackupBase } from 'globals/store/backup.data';
import { InputDialogComponent, InputDialogData, InputDialogReturnData } from '../wizards/input.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { ActionButtonComponent } from '../nav-bar/action-button.component';
import { CommonModule } from '@angular/common';
import { LoaderPaneFragmentComponent } from '../loader/loader-pane-fragment.component';
import { TopMenuComponent } from 'src/app/modules/program/top.menu';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'backups',
    template: `
  
<loader-pane-fragment [trace]="traceNames.viewBackups"></loader-pane-fragment>
<top-menu [showPrint]="true"></top-menu>
<div class="wrap100">
  <div class="list">
    <h3>BACKUPS</h3>
    <div class="hint">click to restore</div>

    <div class="summary" *ngFor="let back of backupList" (click)="loadBackup(back)" [ngClass]="{ backupOnBackup: back.type === 'OnLoadBackup'}">
     {{ back.date | date:"d MMMM hh:mm" }} <div class="previous" *ngIf="back.type === 'OnLoadBackup'">[Last restored]</div>
    </div>
  </div>
  <div class="backup" *ngIf="!!backup || !!loading || !!restoring || !!restored">
    <ng-container *ngIf="!!backup">
      Backup created {{ backupBase.date | date:"d MMMM hh:mm" }} is ready to restore
      <action-button id="restore" [text]="'Restore Backup'" (click)="restoreBackup()"></action-button>
    </ng-container>
    <ng-container *ngIf="!!loading">
      Checking backup...
    </ng-container>
    <ng-container *ngIf="!!restoring">
      Restoring backup...
    </ng-container>
    <ng-container *ngIf="!!restored">
      <h3>Backup restored</h3>
    </ng-container>
  </div>  
</div>
`,
    styleUrls: ["./backups.scss", '../../page.scss'],
    standalone: true,
    imports: [ActionButtonComponent, CommonModule, LoaderPaneFragmentComponent, TopMenuComponent],
})
export class BackupsComponent extends Wrapper<BackupsComponent> {
  event: JoiEvent
  backup: EventBackup
  traceNames = traceNames
  backupBase: EventBackupBase
  backupList: EventBackupBase[]
  loading = false
  restoring = false
  restored = false

  constructor() {
    super()
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('backups', 'backups'), 'backupList')
  }

  async createBackup() {

    const rect = document.getElementById('create').getBoundingClientRect()
    const width = 240 // NEEDS to be wider for performer, or you need to deal with padding issues.  This is a better solution imo
    const data: InputDialogData = {
      title: `Create a backup named`,
      backgroundColor: null,
      successLabel: 'SAVE BACKUP',
      small: true,
      position: { top: rect.bottom + 5, left: rect.right - width },
      placeholder: 'Backup name'
    }

    const result = await openDialogGetResult<InputDialogReturnData>(this.dialog, InputDialogComponent, { width: `${width}px`, autoFocus: true, backdropClass: 'clear', data })
    if (!result) return
    
    this.backupService.makeBackup(this.event, result.values[0] || 'Unnamed Backup')
    
  }

  async loadBackup(backupBase: EventBackupBase) {
    this.backup = null
    this.loading = true
    this.restoring = false
    this.restored = false
    const backup = await this.backupService.loadBackup(backupBase)
    console.log({ backup })
    this.backup = backup
    this.backupBase = backupBase
    this.loading = false
  }

  async restoreBackup() {
    const restoreEl = document.getElementById('restore')
    const previousBackupOnBackup = this.backupList.find(bu => bu.type === 'OnLoadBackup')
    console.log("SHOULD BE RESTORING!", restoreEl)
    const data: ConfirmDeleteData = {
      rect: restoreEl.getBoundingClientRect(),
      title: `Confirm Backup`,
      para: `By clicking RESTORE BACKUP all event data will revert back to the time and date of the backup` ,
      delete_btn_text: 'RESTORE BACKUP',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    this.backup = null
    this.restoring = true
    await this.backupService.restoreBackup(this.backupBase)
    this.restored = true
    this.restoring = false
    this.backupBase = null

    console.log("SHOULD BE RESTORED!")
  }

  async deleteBackup() {
    console.log("SHOULD BE DELETING!")
    await this.backupService.deleteBackup(this.backupBase)
    console.log("SHOULD BE DELETED")
  }

}

